"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinkedItem = exports.isComponent = void 0;
var isComponent = function (node) {
    var _a;
    return ((_a = node.attributes.find(function (attr) { return attr.name === "data-rel"; })) === null || _a === void 0 ? void 0 : _a.value) === "component";
};
exports.isComponent = isComponent;
var isLinkedItem = function (node) {
    var _a;
    return ((_a = node.attributes.find(function (attr) { return attr.name === "data-rel"; })) === null || _a === void 0 ? void 0 : _a.value) === "link";
};
exports.isLinkedItem = isLinkedItem;
